import { __commonJS, __glob } from "./chunk-UM5R4LAF.js";

// build/commercetools/prod/states.json
var require_states = __commonJS({
  "build/commercetools/prod/states.json"(exports, module) {
    module.exports = {
      lineItem: {
        WAITING_FOR_ARTWORK: "2748f11c-e9be-4dac-a566-7fd7beb6ef03",
        WAITING_FOR_DOC_REVIEW: "1fecdde8-7cf9-4338-abeb-8e8e435c2c55",
        WAITING_FOR_SECONDARY_DOC_REVIEW: "28007760-45bc-4345-9ed9-cc1267f48172",
        INITIAL: "8c982122-f1e9-4e57-9a1f-a6698835e876",
        PROCESSING: "c6ce5f15-8f7b-42c6-9fca-8b746c76e9c7",
        CONFIRMED: "0a4aaa63-5371-40d7-8898-d73769a4c0f3",
        DOC_REVIEW_PROOFING: "d4d229c0-ab37-4197-8f35-d3c6a19ddd90",
        WAITING_FOR_PROPOSAL: "aa5557a8-a3c9-4eff-8055-7d9f24f46c61",
        DOC_REVIEW_APPROVED: "d9dd6aba-3853-40dc-96cf-6f29c7bfc5a2",
        DOC_REVIEW_FAILED: "ff96f093-ccd9-4945-bbba-08ac2f4bf402",
        DOC_REVIEW_REJECTED: "ca1a4086-0868-4e19-a070-ad7295224d6a",
        DOC_REVIEW_IN_PROGRESS: "97cc0d7e-c480-46b0-8ede-8fcdb057b23c",
        DOC_FEEDBACK_REQUESTED: "f2ef3dfb-0ec9-49b2-9d23-0aeaf6a09e89",
        READY_FOR_FULFILLMENT: "8913c7ca-a4f9-41af-b840-5f50dbd2fe58",
        FULFILLMENT_REJECTED: "0ebfba27-8fd9-4ee4-95ff-d6605da27e77",
        FULFILLMENT_ACCEPTED: "b7179239-a425-4258-adf4-1b4b358afe8a",
        FULFILLMENT_ERROR: "eb60e270-e5b3-40ed-8ff4-71b8ffc4deac",
        PRINTING_IN_PROGRESS: "841d69e3-a3c4-4b08-80be-2dd2135b09e1",
        SHIPPED: "6004f7d5-62f9-47f4-9c3a-bbce100db3b1",
        CANCELLED: "ec6c5bf7-c17e-48f1-887d-e2d3e72c9baa",
        SENT_TO_MCP: "aaebef35-6498-4b28-b931-8cda1efda424",
        HELD: "e52fabe6-9fdc-478e-99c6-c17ea2069ac7",
        HOLD_FOR_INJECTION: "6f3b5fd0-4a6a-4b5b-a1eb-fad1f3652e90",
        PROCESSING_CLOUDLAB_ARTWORK: "07b35ece-4325-46de-b2a8-fd44f7d361a9",
        PROCESSING_CLOUDLAB_ARTWORK_DONE: "8b6d97d4-ae23-4870-9e51-68d064dd4abd",
        PROCESSING_CLOUDLAB_ARTWORK_FAILED: "956b77a7-d293-41b4-900b-a515ccef375d",
        PREPARING_DOC_FOR_REVIEW: "5522b974-ca59-4c7e-9dce-d68d0fb31d43",
        IN_STANDARD_REVIEW: "a781340f-9d02-4376-aa14-033924f4e527"
      },
      order: {
        OPEN: "02b9ab6e-771c-4dd4-90d7-7d6bac598e26",
        PROCESSING: "28bf3ff0-f0a1-4c08-aec5-ebff1247994e",
        CONFIRMED: "60f77020-157e-47b6-8353-35ffd0293c4c",
        COMPLETED: "cd1d53e3-b0b2-48ec-b0f7-7f592595a934",
        CANCELLED: "b172736b-7655-4e8f-bce1-3a3c05466353"
      },
      payment: {
        BALANCE_DUE: "BalanceDue",
        FAILED: "Failed",
        PENDING: "Pending",
        CREDIT_OWED: "CreditOwed",
        PAID: "Paid"
      },
      service: {
        INITIAL: "8c982122-f1e9-4e57-9a1f-a6698835e876",
        CONFIRMED: "0a4aaa63-5371-40d7-8898-d73769a4c0f3",
        SERVICE_IN_PROGRESS: "4dfe5c74-9f86-4380-824a-aa4bb8500f7b",
        EDIT_IN_PROGRESS: "81243e66-29bf-410c-a872-e0924e568e16",
        SERVICE_DELIVERED: "a854787b-b165-45e2-a2be-0c7f07e55750",
        CANCELLED: "ec6c5bf7-c17e-48f1-887d-e2d3e72c9baa"
      }
    };
  }
});

// build/commercetools/staging/states.json
var require_states2 = __commonJS({
  "build/commercetools/staging/states.json"(exports, module) {
    module.exports = {
      lineItem: {
        WAITING_FOR_ARTWORK: "f882cb8c-9a35-40c5-8528-c21b26acbf65",
        WAITING_FOR_DOC_REVIEW: "c76353df-541e-4a4f-8914-409f747a1a20",
        WAITING_FOR_SECONDARY_DOC_REVIEW: "604774b1-171d-4f49-adb6-3f1d613fa4b6",
        INITIAL: "76a76c0f-9da3-47f8-9923-1dc549ae6f00",
        PROCESSING: "a168736f-5fa9-421f-ad59-00084231dd3d",
        CONFIRMED: "37bb45cd-6449-4f7b-9209-5130aa80b059",
        DOC_REVIEW_PROOFING: "ea14106e-b678-4d73-a36d-84c265ea548e",
        WAITING_FOR_PROPOSAL: "d916a1d3-07c8-4056-a34b-de7cbc4da4b1",
        DOC_REVIEW_APPROVED: "079c4c5f-df1f-4bad-9fbc-79566d56eb97",
        DOC_REVIEW_FAILED: "265cf028-4b0e-457e-b22d-f3b82261459e",
        DOC_REVIEW_REJECTED: "ca773618-f97f-4e0c-afde-9adff64de087",
        DOC_REVIEW_IN_PROGRESS: "dbc2fabe-73b7-4a4e-82f9-5ff252e5bf5d",
        DOC_FEEDBACK_REQUESTED: "38cada67-5554-436f-b015-383836297f35",
        READY_FOR_FULFILLMENT: "daeb20b5-2edd-43df-b8a1-cdfaf8ab6d6b",
        FULFILLMENT_REJECTED: "30936627-6b38-42bd-8113-5422c3162c91",
        FULFILLMENT_ACCEPTED: "813e8f4c-e59d-493f-ace6-3d5b97531b64",
        FULFILLMENT_ERROR: "241c3011-c79f-42e4-9ada-7063c1da79f0",
        PRINTING_IN_PROGRESS: "71aa4579-bc9f-473f-b16b-89ba83b03458",
        SHIPPED: "51a1b3cf-2fd6-4868-846a-d83e45219f66",
        CANCELLED: "56fef091-b60a-4b2c-b7fb-0319798a0185",
        SENT_TO_MCP: "b3d20f5b-e2a6-4e48-889c-cce42b0f7c90",
        HELD: "3fe48643-dd34-4a58-96a8-f8c486d80610",
        HOLD_FOR_INJECTION: "c3f8529f-1518-46f3-8172-24572e07eb85",
        PROCESSING_CLOUDLAB_ARTWORK: "915b6194-c67c-40dd-bdab-3fa5b5d683a5",
        PROCESSING_CLOUDLAB_ARTWORK_DONE: "59cc274f-55db-46e2-8623-a6e44c28c57e",
        PROCESSING_CLOUDLAB_ARTWORK_FAILED: "1ff74ab8-8c8e-4e6f-8a46-d51fd606a2f5",
        PREPARING_DOC_FOR_REVIEW: "ea00881e-72a4-463e-9898-1414f5d49ec9",
        IN_STANDARD_REVIEW: "3fdeac96-5b67-49f8-a924-6abf93ddb6e0"
      },
      order: {
        OPEN: "617956e5-7c27-4672-9ec6-f18f1e8e77aa",
        PROCESSING: "9562fb32-1232-4c8b-a7ed-09718bb44787",
        CONFIRMED: "b5240713-627a-4423-885e-41259e2d5507",
        COMPLETED: "56fd9a1d-5fc6-4fae-b66e-3b65078d4030",
        CANCELLED: "7c8cb863-6519-4bb1-a9b3-061d1ef540b9"
      },
      payment: {
        BALANCE_DUE: "BalanceDue",
        FAILED: "Failed",
        PENDING: "Pending",
        CREDIT_OWED: "CreditOwed",
        PAID: "Paid"
      },
      service: {
        INITIAL: "76a76c0f-9da3-47f8-9923-1dc549ae6f00",
        CONFIRMED: "37bb45cd-6449-4f7b-9209-5130aa80b059",
        SERVICE_IN_PROGRESS: "af4c0cfe-2bcf-490b-9e3c-a4e954f8ff08",
        EDIT_IN_PROGRESS: "1fb7b5cc-67ed-4022-859d-445935565773",
        SERVICE_DELIVERED: "f8572e4f-0758-4607-b13b-72cf765a5af1",
        CANCELLED: "56fef091-b60a-4b2c-b7fb-0319798a0185"
      }
    };
  }
});

// require("../build/commercetools/**/*/states.json") in src/states.ts
var globRequire_build_commercetools_states_json = __glob({
  "../build/commercetools/prod/states.json": () => require_states(),
  "../build/commercetools/staging/states.json": () => require_states2()
});

// src/states.ts
var SERVICE_ITEM_STATES = {
  INITIAL: "Initial",
  CONFIRMED: "Confirmed",
  SERVICE_IN_PROGRESS: "ServiceInProgress",
  EDIT_IN_PROGRESS: "EditInProgress",
  SERVICE_DELIVERED: "ServiceDelivered",
  CANCELLED: "Cancelled"
};
var LINE_ITEM_STATES = {
  WAITING_FOR_ARTWORK: "WaitingForArtwork",
  WAITING_FOR_DOC_REVIEW: "WaitingForDocReview",
  WAITING_FOR_SECONDARY_DOC_REVIEW: "WaitingForSecondaryDocReview",
  INITIAL: "Initial",
  PROCESSING: "Processing",
  CONFIRMED: "Confirmed",
  DOC_REVIEW_PROOFING: "DocReviewInProofing",
  WAITING_FOR_PROPOSAL: "WaitingForProposal",
  DOC_REVIEW_APPROVED: "DocReviewApproved",
  DOC_REVIEW_FAILED: "DocReviewFailed",
  DOC_REVIEW_REJECTED: "DocReviewRejected",
  DOC_REVIEW_IN_PROGRESS: "DocReviewInProgress",
  DOC_FEEDBACK_REQUESTED: "DocFeedbackRequested",
  READY_FOR_FULFILLMENT: "ReadyForFulfillment",
  FULFILLMENT_REJECTED: "FulfillmentRejected",
  FULFILLMENT_ACCEPTED: "FulfillmentAccepted",
  FULFILLMENT_ERROR: "FulfillmentError",
  PRINTING_IN_PROGRESS: "PrintingInProgress",
  SHIPPED: "Shipped",
  CANCELLED: "Cancelled",
  SENT_TO_MCP: "SentToMCP",
  HELD: "Held",
  HOLD_FOR_INJECTION: "HoldForInjection",
  PROCESSING_CLOUDLAB_ARTWORK: "ProcessingCloudlabArtwork",
  PROCESSING_CLOUDLAB_ARTWORK_DONE: "ProcessingCloudlabArtworkDone",
  PROCESSING_CLOUDLAB_ARTWORK_FAILED: "ProcessingCloudlabArtworkFailed",
  PREPARING_DOC_FOR_REVIEW: "PreparingDocForReview",
  IN_STANDARD_REVIEW: "InStandardReview"
};
var ORDER_STATES = {
  OPEN: "Open",
  PROCESSING: "Processing_order",
  CONFIRMED: "Confirmed_order",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled_order"
};
var PAYMENT_STATES = {
  BALANCE_DUE: "BalanceDue",
  FAILED: "Failed",
  PENDING: "Pending",
  CREDIT_OWED: "CreditOwed",
  PAID: "Paid"
};
var getStates = env => globRequire_build_commercetools_states_json("../build/commercetools/".concat(env, "/states.json"));
var getStateNameById = (env, id) => {
  const {
    lineItem,
    order,
    service
  } = getStates(env);
  const [lineItemStateKey] = Object.entries(lineItem).find(_ref => {
    let [, value] = _ref;
    return id === value;
  }) || [];
  if (lineItemStateKey) {
    return LINE_ITEM_STATES[lineItemStateKey];
  }
  const [orderStateKey] = Object.entries(order).find(_ref2 => {
    let [, value] = _ref2;
    return id === value;
  }) || [];
  if (orderStateKey) {
    return ORDER_STATES[orderStateKey];
  }
  const [serviceStateKey] = Object.entries(service).find(_ref3 => {
    let [, value] = _ref3;
    return id === value;
  }) || [];
  if (serviceStateKey) {
    return SERVICE_ITEM_STATES[serviceStateKey];
  }
  return null;
};
var getLineItemStateIdByName = (env, stateName) => {
  const state = Object.entries(LINE_ITEM_STATES).find(_ref4 => {
    let [, value] = _ref4;
    return stateName === value;
  });
  if (!state) {
    return null;
  }
  const {
    lineItem
  } = getStates(env);
  const [stateKey] = state;
  return lineItem[stateKey];
};
export { SERVICE_ITEM_STATES, LINE_ITEM_STATES, ORDER_STATES, PAYMENT_STATES, getStates, getStateNameById, getLineItemStateIdByName };